import { gql } from '@provision/graphql-client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { SIGNAL_BUSINESS_HOURS_FRAGMENT } from './signal-business-hours.fragments';

export const CREATE_SIGNAL_BUSINESS_HOURS_QUERY = gql`
  mutation CreateSignalBusinessHours(
    $data: SignalBusinessHoursDataInput #    $includeCreatedByUser: Boolean = false
  ) {
    createSignalBusinessHours(data: $data) {
      ...SignalBusinessHoursFields
    }
  }
  ${SIGNAL_BUSINESS_HOURS_FRAGMENT}
`;

export const DELETE_SIGNAL_BUSINESS_HOURS_QUERY = gql`
  mutation DeleteSignalBusinessHours($conditions: [ConditionInput]) {
    deleteSignalBusinessHours(conditions: $conditions) {
      id
    }
  }
`;

export const UPDATE_SIGNAL_BUSINESS_HOURS_QUERY = gql`
  mutation UpdateSignalBusinessHours(
    $conditions: [ConditionInput]
    $data: SignalBusinessHoursDataInput
  ) {
    updateSignalBusinessHours(conditions: $conditions, data: $data) {
      ...SignalBusinessHoursFields
    }
  }
  ${SIGNAL_BUSINESS_HOURS_FRAGMENT}
`;

export const GET_SIGNAL_BUSINESS_HOURS_QUERY = gql`
  query GetSignalBusinessHours($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "SignalBusinessHours") {
    getSignalBusinessHours(queryParams: $params) {
      records {
        ...SignalBusinessHoursFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${SIGNAL_BUSINESS_HOURS_FRAGMENT}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_DEFAULT_SIGNAL_BUSINESS_HOURS_QUERY = gql`
  query GetDefaultSignalBusinessHours @entity(name: "SignalBusinessHours") {
    getDefaultSignalBusinessHours {
      records {
        id
        urgency
        signalBusinessHours {
          id
          weekday
          startHour
          startMinute
          endHour
          endMinute
        }
      }
    }
  }
`;
